export default {
  'name': {
    'key': 'name',
    'name': '姓名',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'gender': {
    'key': 'gender',
    'name': '性别',
    'type': 'radio',
    'required': true,
    'labels': [
      { 'id': 'g1', 'value': 'M', 'name': '先生', 'checked': true },
      { 'id': 'g2', 'value': 'F', 'name': '女士' }
    ],
    'regName': 'checkIsEmpty'
  },
  // 'birthday': {
  //   'key': 'birthday',
  //   'name': '生日',
  //   'required': true,
  //   'type': 'DatePicker',
  //   'regName': 'checkIsEmpty'
  // },
  'email': {
    'key': 'email',
    'name': 'E-mail',
    'required': true,
    'type': 'default',
    'regName': 'checkMail'
  },
  'wechat': {
    'key': 'wechat',
    'name': '微信号',
    'required': true,
    'type': 'default',
    'regName': 'checkIsEmpty'
  },
  'focus_areas_tags': {
    'key': 'focus_areas_tags',
    'name': '个人专注领域',
    'type': 'AutoComplete',
    'regName': 'checkIsEmpty',
    'required': true
  }, // 个人专注领域
  'expect_to_join': {
    'key': 'expect_to_join',
    'name': '期待加入的城市',
    'type': 'AutoComplete',
    'regName': 'checkIsEmpty',
    'required': true
  },
  'referrers': {
    'key': 'referrers',
    'name': '推荐人',
    'type': 'AutoComplete',
    'required': false,
    'regName': 'checkMaxLength',
    'maxLength': 60
  }
  // 期望加入的分会
  // 'willingness_to_participate': {
  //   'key': 'willingness_to_participate',
  //   'name': '是否愿意参与、组织学员交流活动',
  //   'subTitle': 'TGO 鲲鹏会是学员共建组织，“投入越多，收获越多”我们希望所有学员能够参与其中',
  //   'type': 'checkbox',
  //   'required': true,
  //   'labels': [
  //     {'id': 'w1', 'value': 1, 'name': '愿意参与小组活动（约4小时／每月）'},
  //     {'id': 'w2', 'value': 2, 'name': '愿意担任小组组长／纪律委员／财务委员（约3小时／月）'},
  //     {'id': 'w3', 'value': 3, 'name': '愿意将来担任分会董事会岗位（约10小时／月）'},
  //     {'id': 'w4', 'value': 4, 'name': '时间不好确定，到时再说'}
  //   ],
  //   'regName': 'checkIsEmpty'
  // },
  // 'size': {
  //   'key': 'size',
  //   'name': '穿衣尺码',
  //   'type': 'radio',
  //   'labels': [
  //     {'id': 's1', 'value': 1, 'name': 'S 155-160'},
  //     {'id': 's2', 'value': 2, 'name': 'M 160-165'},
  //     {'id': 's3', 'value': 3, 'name': 'L 165-170'},
  //     {'id': 's4', 'value': 4, 'name': 'XL 170-175'},
  //     {'id': 's5', 'value': 5, 'name': 'XXL 175-180'},
  //     {'id': 's6', 'value': 6, 'name': 'XXXL 180-185'},
  //     {'id': 's7', 'value': 7, 'name': 'XXXXL 185-190'}
  //   ],
  //   'regName': 'checkIsEmpty'
  // }
}
